export default [
    {
        path: '/incoming-payment/:id?',
        name: 'incoming_payment_detail',
        component: () => import('@src/incoming-payment/incoming-payment.vue'),
        props(route: any) {
            return { id: Number.parseInt(route.params.id) };
        },
        meta: {
            title: 'Eingehende Zahlung',
        },
    },
];
